import { useQuery } from "@tanstack/react-query";
import { CalculatorKeys } from "web_myplann/Api/Calculators/CalculatorKeys";
import { mapCalculatorAccess } from "web_myplann/Calculators/Utils/mapCalculatorAccess";
import {
	type CalculatorAccessResponseDTO,
	getCalculatorAccessV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useCalculatorAccessQuery = () =>
	useQuery({
		queryKey: CalculatorKeys.access(),
		queryFn: processResponse(() => getCalculatorAccessV2(), {
			skipToastFor: true,
		}),
		select: (response: { data: CalculatorAccessResponseDTO[] }) =>
			mapCalculatorAccess(response.data),
	});
